exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout[data-v-e518d5d8]{border:1px solid #d7dde4;background:#f5f7f9;position:relative;border-radius:4px;overflow:hidden}.layout-logo[data-v-e518d5d8]{margin-top:-10px;width:100px;height:30px;background:#5b6270;border-radius:3px;float:left;position:relative;top:15px;left:20px}.layout-nav[data-v-e518d5d8]{width:420px;margin:0 auto;margin-right:20px}.scan-number[data-v-e518d5d8]{width:15%;height:65%;position:absolute;top:182px;right:3%}.scan-fixed[data-v-e518d5d8]{position:fixed;top:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e518d5d8","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/case/caseManager/CaseManager.vue
// module id = zZKS
// module chunks = 2